import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { Select, Spin } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import {Payroll_API_BASE_URL} from "../PConfig/PConfig";

const ProcessPayroll = () => {
  const [dataLoading, setDataLoading] = useState(false);
  console.log("dataLoading",setDataLoading);
    const [tokenData, setTokenData] = useState(null);
    const [superIdData, setSuperIdData] = useState(null);
    const [branchesList, setBranchesList] = useState([]);
      const [SelectedBranchId, setSelectedBranchId] = useState([0]);
      const [PayPeriodlist, setPayPeriodlist] = useState([]);
     const [DeptList, setDeptList] = useState([]);
      const [SelectedDeptId, setSelectedDeptId] = useState([0]);
      const [selectedPayPeriod, setSelectedPayPeriod] = useState({
        value: 0,
        label: "All",
      });
    const navigate = useNavigate();  
  // console.log(setDataLoading);
  const salaryData = [
  {
    key: 1,
    employeeid: 1001,
    employee: "Ravi Kumar",
    Designation: "HR Executive",
    Grosssalary: 45000,
    WorkDays: 26,
    pdays: 24,
    basic: 20000,
    hra: 10000,
    Conveyance: 2000,
    lessmedicalallowance: 1500,
  },
  {
    key: 2,
    employeeid: 1002,
    employee: "Anjali Sharma",
    Designation: "Accountant",
    Grosssalary: 50000,
    WorkDays: 26,
    pdays: 22,
    basic: 22000,
    hra: 12000,
    Conveyance: 2500,
    lessmedicalallowance: 1800,
  },
  {
    key: 3,
    employeeid: 1003,
    employee: "Suresh Reddy",
    Designation: "Software Engineer",
    Grosssalary: 65000,
    WorkDays: 26,
    pdays: 26,
    basic: 30000,
    hra: 15000,
    Conveyance: 3000,
    lessmedicalallowance: 2000,
  },
  {
    key: 4,
    employeeid: 1004,
    employee: "Neha Verma",
    Designation: "Operations Manager",
    Grosssalary: 70000,
    WorkDays: 26,
    pdays: 23,
    basic: 32000,
    hra: 16000,
    Conveyance: 3500,
    lessmedicalallowance: 2200,
  },
  {
    key: 5,
    employeeid: 1005,
    employee: "Amit Patel",
    Designation: "Sales Executive",
    Grosssalary: 48000,
    WorkDays: 26,
    pdays: 25,
    basic: 21000,
    hra: 11000,
    Conveyance: 2500,
    lessmedicalallowance: 1700,
  },
];


  const [data] = useState(salaryData);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => index + 1,
    },
    {
      title: "EmpID",
      dataIndex: "employeeid",
    },
    {
      title: "Emp",
      dataIndex: "employee",
    },
    {
      title: "Designation",
      dataIndex: "Designation",
    },
    {
      title: "Gross Sal",
      dataIndex: "Grosssalary",
    },
    {
      title: "WorkDays",
      dataIndex: "WorkDays",
    },
    {
      title: "Prs Days",
      dataIndex: "pdays",
    },
    {
      title: "Basic",
      dataIndex: "basic",
    },
    {
      title: "HRA",
      dataIndex: "hra",
    },
    {
      title: "Conveyance",
      dataIndex: "Conveyance",
    },
    {
      title: "Medi Allowa",
      dataIndex: "lessmedicalallowance",
    },
  ];
  const handleReload = () => {
    window.location.reload();
  };

  const handleDownloadExcel = () => {
    if (data.length === 0) return;

    const wb = XLSX.utils.book_new();
    const wsData = data.map((item, index) => ({
      "S.No": index + 1,
      Employee: item.employee,
      "Emp Code": item.empCode,
      "Monthly Salary": item.monthlySalary,
      "Yearly CTC": item.yearlyCTC,
      Group: item.group,
      "Start Date": formatDate(item.startDate),
      "End Date": formatDate(item.endDate),
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Annual CTC");
    XLSX.writeFile(wb, "Employee_Annual_CTC.xlsx");
  };

  const generatePDF = () => {
    if (data.length === 0) return;

    const doc = new jsPDF();
    doc.text("Employee Annual CTC Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Employee",
      "Emp Code",
      "Monthly Salary",
      "Yearly CTC",
      "Group",
      "Start Date",
      "End Date",
    ];
    const tableRows = data.map((item, index) => [
      index + 1,
      item.employee,
      item.empCode,
      `$${item.monthlySalary.toLocaleString()}`,
      `$${item.yearlyCTC.toLocaleString()}`,
      `$${item.group.toLocaleString()}`,
      formatDate(item.startDate),
      formatDate(item.endDate),
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
    doc.save("Employee_Annual_CTC.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      PDF
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  
    useEffect(() => {
      const token = sessionStorage.getItem("authToken");
      const superId = sessionStorage.getItem("superId");
  
      if (token && superId) {
        setTokenData(token);
        setSuperIdData(superId);
      } else {
        console.warn("User data not found in sessionStorage");
        navigate("/signin");
      }
    }, [navigate]);
  
    useEffect(() => {
      if (tokenData && superIdData) {
        const fetchBranchsList = async () => {
          try {
            const response = await fetch(
              `${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  // Authorization: `Bearer ${tokenData}`,
                  Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
  
                },
              }
            );
  
            if (!response.ok) {
              throw new Error("Failed to fetch Branches");
            }
  
            const data = await response.json();
  
            if (data.status) {
              setBranchesList(data.ResultData);
            } else {
              console.error("Invalid Branches response structure:", data);
            }
          } catch (error) {
            console.error("Error fetching BranchesList:", error.message);
          }
        };
        fetchBranchsList();
      }
    }, [superIdData, tokenData]);
  
    useEffect(() => {
      if (tokenData && superIdData) {
        const fetchDeptList = async () => {
          try {
            const response = await fetch(
              `${Payroll_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  // Authorization: `Bearer ${tokenData}`,
                  Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
  
                },
              }
            );
  
            if (!response.ok) {
              throw new Error("Failed to fetch Dept");
            }
  
            const data = await response.json();
  
            if (data.status) {
              setDeptList(data.ResultData);
            } else {
              console.error("Invalid Dept response structure:", data);
            }
          } catch (error) {
            console.error("Error fetching DeptList:", error.message);
          }
        };
        fetchDeptList();
      }
    }, [superIdData, tokenData]);
  
    useEffect(() => {
      if (tokenData && superIdData) {
        const fetchPayPeriodsList = async () => {
          try {
            const response = await fetch(
              `${Payroll_API_BASE_URL}payroll/payroll/getPayPeriods?SuperId=${superIdData}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  // Authorization: `Bearer ${tokenData}`,
                  Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
  
                },
              }
            );
  
            if (!response.ok) {
              throw new Error("Failed to fetch Employees");
            }
  
            const data = await response.json();
  
            if (data.status) {
              setPayPeriodlist(data.ResultData);
            } else {
              console.error("Invalid Employees response structure:", data);
            }
          } catch (error) {
            console.error("Error fetching EmployeesList:", error.message);
          }
        };
        fetchPayPeriodsList();
      }
    }, [superIdData, tokenData]);
  const BranchesOptions = [
    { label: "All Branches", value: 0 },
    ...(branchesList?.map((branch) => ({
      label: branch.Name,
      value: branch.branchid,
    })) || []),
  ];
  const DeptOptions = [
    { label: "All Dept", value: 0 },
    ...(DeptList?.map((Dept) => ({
      label: Dept.Name,
      value: Dept.DepartmentId,
    })) || []),
  ];
  const PayperiodOptions = [
    { label: "All PayPeriods", value: 0 },
    ...(PayPeriodlist?.map((period) => ({
      label: period.Name,
      value: period.Id,
    })) || []),
  ];
  
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Process PayRoll
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your Process Payroll here</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={generatePDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="PDF"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link onClick={handleDownloadExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="Excel"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          <div className="mt-4">
            <div className="card p-4">
              <div className="row align-items-center g-3">
                  {/* Effective Pay Period Dropdown */}
                <div className="col-md-3">
                  <label className="form-label">Pay Period</label>
             <Select
                                    showSearch
                                    labelInValue
                                    placeholder="Choose PayPeriod"
                                    value={selectedPayPeriod}
                                    onChange={(option) => setSelectedPayPeriod(option)}
                                    options={PayperiodOptions}
                                    style={{ width: 170, height: 37 }}
                                    filterOption={(input, option) =>
                                      option?.label?.toLowerCase().includes(input.toLowerCase())
                                    }
                                  />
                </div>
             

                {/* Salary Group Master Dropdown */}
                <div className="col-md-3">
                  <label className="form-label">Branch</label>
                  <Select
                                         showSearch
                                         placeholder="Choose Branch"
                                         value={SelectedBranchId}
                                         onChange={(val) => setSelectedBranchId(val)}
                                         options={BranchesOptions}
                                         style={{ width: 170, height: 37 }}
                                         filterOption={(input, option) =>
                                           option?.label?.toLowerCase().includes(input.toLowerCase())
                                         }
                                       />
                </div>

                 {/* Employee Dropdown */}
                <div className="col-md-3">
                  <label className="form-label">Department</label>
                 <Select
                                        showSearch
                                        placeholder="Choose Dept"
                                        value={SelectedDeptId}
                                        onChange={(val) => setSelectedDeptId(val)}
                                        options={DeptOptions}
                                        style={{ width: 170, height: 37 }}
                                        filterOption={(input, option) =>
                                          option?.label?.toLowerCase().includes(input.toLowerCase())
                                        }
                                      />
                </div>

                {/* Active Pay Button */}
                <div className="col-md-2 d-flex align-items-center justify-content-center">
                  <button
                    className="btn btn-primary w-100"
                    style={{ marginBottom: "-1.80rem" }}
                  >
                    <i className="fas fa-money-check-alt"></i> Process PayRoll
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm"
                    // value={searchInput}
                    // onChange={(e) => setSearchInput(e.target.value)}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="d-flex right-content align-items-end ">
                <div className="">
                  {/* <label className="form-label">Employee</label> */}
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 200 }}
                  >
                    <Select
                      showSearch
                      placeholder="Pay Period"
                      //   value={slectedEmp || undefined}
                      //   onChange={handleEmpChange}
                      filterOption={(input, option) =>
                        option?.label
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      //   options={empOptions}
                      style={{ width: 170, height: 37 }}
                    />
                  </div>
                </div>
                <div className="">
                  {/* <label className="form-label">Department</label> */}
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 200 }}
                  >
                    <Select
                      showSearch
                      placeholder="Branch"
                      //   value={slectedDept || undefined}
                      //   onChange={handleDeptChange}
                      filterOption={(input, option) =>
                        option?.label
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      //   options={departmentOptions}
                      style={{ width: 170, height: 37 }}
                    />
                  </div>
                </div>
                {/* <div className="d-flex right-content align-items-end gap-2">
                  <button className="btn btn-primary">
                    <FontAwesomeIcon
                      icon={faTrash}
                      className="me-1"
                      title="delete"
                    />
                  </button>

                  <button className="btn btn-primary">
                    <FontAwesomeIcon icon={faSyncAlt} title="Processing" />
                  </button>
                </div> */}
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive brand-table">
                {dataLoading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <Table
                    columns={columns}
                    dataSource={salaryData}
                    rowKey="id"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default ProcessPayroll;
